import References from '@/services/Api/Awards/References';
import { handleAuthorization, handleFormValidations } from '@ifac/ui';

export default {
  methods: {
    mx_fetchReference(params) {
      return References.get(this.mx_referenceId, params);
    },
    mx_updateReference(payload) {
      this.formErrors = {};
      References.update(this.reference.id, {
        form_values: payload,
      }).then(() => {
        this.$snack.success({ text: 'Reference letter saved' });
      }).catch((error) => {
        this.handleError(error);
      });
    },
    mx_submitReference(payload) {
      this.formErrors = {};
      return References
        .submit(this.mx_referenceId, {
          form_values: payload,
        })
        .then(() => {
          this.$snack.success({ text: 'Reference letter submitted' });
          this.$router.push({
            name: 'References',
            query: { section: 'historic' },
          });
        }).catch((error) => {
          this.handleError(error);
        });
    },
    handleError(error) {
      handleAuthorization(error).then((msg) => {
        if (msg) {
          this.$snack.success({ text: msg });
        }
      });

      handleFormValidations(error).then((errors) => {
        if (errors) {
          this.$snack.success({
            text: 'You have some validation errors, try again please.',
          });
          this.formErrors = errors;
        }
      });
    },
  },
  computed: {
    mx_referenceId() {
      return this.$route.params.reference;
    },
  },
};
